<template>
  <Loading
    v-if="composable.loading.setting.isShow"
    :content="composable.loading.setting.content"
  />

  <div
    v-if="page === 'login'"
    class="page"
  >
    <Header
      :setting="{
        title: '登入',
        hasCancelMethod: false,
      }"
    />
    <div class="page__form mv8">
      <input
        v-model.trim="loginForm.twid"
        type="text"
        placeholder="身份證/Resident ID No."
        class="mb5"
      >
      <input
        v-model.trim="loginForm.birthdate"
        type="text"
        placeholder="西元生日/Birth Date(YYYYMMDD)"
        class="mb5"
      >
      <input
        v-model="loginForm.password"
        type="password"
        placeholder="密碼/Password"
      >
    </div>
    <div
      @click="login"
      class="label label--primary mb4"
    >
      登入
    </div>
    <div
      @click="$router.push({path: '/member/sign-up'})"
      class="label label--secondary mb4"
    >
      申請帳號
    </div>
    <div
      @click="$router.push({path: '/member/account-recovery'})"
      class="label label--secondary mb4"
    >
      忘記密碼
    </div>
  </div>

  <Death
    v-else
    :message="composable.death.message"
    :page="page"
  />

  <Modal
    v-if="composable.modal.setting.isShow"
    :setting="composable.modal.setting"
    @close="composable.modal.close"
    @toHome="toHome"
  />
</template>

<script>
import { reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import composable from '@/composable/index';
import spiderman from '@/spiderman/index';
import api from '@/api/index';

export default {
  setup() {
    const page = ref('login');
    const loginForm = reactive({
      twid: '',
      birthdate: '',
      password: '',
    });
    const router = useRouter();

    async function login() {
      try {
        spiderman.form.verify(loginForm);
        loginForm.birthdate = spiderman.moment(loginForm.birthdate).format('YYYY-MM-DD');

        composable.loading.show('登入中，請稍候');

        const response = await api.member.login(composable.member, loginForm);
        composable.member.updateInfo(response);

        composable.modal.done(response.message);
      } catch (error) {
        composable.modal.alert(error);
      } finally {
        composable.loading.close();
      }
    }

    function toHome() {
      composable.modal.close();
      router.push({ path: '/home' });
    }

    return {
      page,
      composable,
      loginForm,
      login,
      toHome,
    };
  },
};
</script>
